export const GET_COUNTY_DETAILS = 'GET_COUNTY_DETAILS'
export const GET_FETCH_COUNTY_DETAILS_REQUEST_STATUS = 'GET_SET_COUNTY_DETAILS_REQUEST_STATUS'